import axios from "../config/network-config";

const Network = {
 
  execute(
    method = "GET",
    webservice,
    params = {},
    payload,
    headers = {},
    responseType = 'json',
    beforeSend = (data, headers) => { return data }
  ) {

    params = {'webservice': webservice, ...params};
    
    let requestHeader = {...headers, ...axios.defaults.headers};
    
    let config = {
      method,
      transformRequest: beforeSend,
      params,
      responseType,
      headers: requestHeader,
      onUploadProgress: progressEvent => {},
      onDownloadProgress: progressEvent => {}
    };

    if (method === "POST" || method === "PUT" || method === "PATCH") {
      if(payload instanceof FormData) {
        config.data = payload;
      } else {
        config.data = JSON.stringify(payload);
      }
    }

    return axios(config)
      .then(res => {
        return res;
      })
      .catch(err => {
        console.log(err);
      });
  }  
} 

export default Network;
